/** Public visitor entry (no session required). */
export function isPublicEntryPath(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/login" ||
    pathname === "/start" ||
    pathname.startsWith("/go")
  );
}

/** MAX bot deep link that opens the MVK mini-app (no QR payload). */
export function maxMiniAppOpenUrl(): string {
  const fromEnv = (import.meta.env.VITE_MAX_BOT_DEEP_LINK as string | undefined)?.trim();
  if (fromEnv) return fromEnv;
  return "https://max.ru/id7725558003_3_bot?startapp";
}

/** Bot dialog deep link (?start=) — activates chat, does not open mini-app. */
export function maxBotChatStartUrl(payload = "start"): string {
  const base = maxMiniAppOpenUrl().split("?")[0]!.replace(/\/+$/, "");
  return `${base}?start=${encodeURIComponent(payload)}`;
}
